import { Icon, mergeStyles, PartialTheme, Theme } from '@fluentui/react';
import { ControlBarButtonStyles, ScreenShareButton, usePropsFor, useTheme } from '@azure/communication-react';
import React, { useCallback } from 'react';
import { svgIconStyle } from '../../styles';

interface ControlBarScreenShareButtonProps {
    styles?: ControlBarButtonStyles;
}

export const ControlBarScreenShareButton = (props: ControlBarScreenShareButtonProps) => {
    const screenShareProps = usePropsFor(ScreenShareButton);
    const shareDisabled = screenShareProps.disabled;
    const themeV8 = useTheme();

    const shareButtonOn = useCallback(() => (
      <Icon
        iconName="ControlButtonScreenShareStop"
        className={mergeStyles({
          svg: svgIconStyle(themeV8, shareDisabled)
        })}
    />), [shareDisabled, themeV8]);

    const shareButtonOff = useCallback(() => (
      <Icon
        iconName="ControlButtonScreenShareStart"
        className={mergeStyles({
          svg: svgIconStyle(themeV8, shareDisabled)
        })}
    />), [shareDisabled, themeV8]);

    return (screenShareProps && <ScreenShareButton {...screenShareProps}
        onRenderOnIcon={shareButtonOn}
        onRenderOffIcon={shareButtonOff}
        styles={props.styles}
    />)
}
